export const environment = {
  production: false,
  domain: 'dev.mataloka.com',
  apiUrl: 'https://api-dev.mataloka.com/api/v1',
  API_KEY: 'AIzaSyDYHssjk3UgLxTfgtGUosGp60oMktKrouU',
  appName: 'MataLoka Dev',
  geoapifyApiKey: '2825cff5a6fc4254838f14e73c1a9ecb',
  googleClientId: '137564986543-7ob701dlia3cdhc4o5eq0s9n989vbpav.apps.googleusercontent.com',
  features: {
    auth: true,
    dsp: true,
    ssp: true
  },
  loginDomain: 'https://dev.mataloka.com',
  allowedRoutes: [
    '/main/welcome',
    '/main/campaign',
    '/main/inventory',
    '/main/account',
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password'
  ]
};
